import { render, staticRenderFns } from "./EcommerceBlogsTable.vue?vue&type=template&id=c0dfe24e&scoped=true&"
import script from "./EcommerceBlogsTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceBlogsTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceBlogsTable.vue?vue&type=style&index=0&id=c0dfe24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dfe24e",
  null
  
)

export default component.exports